import concat from 'lodash/concat';
//
import { COLLECT_PLUS_OWNER_ID } from '../../../constants/clickCollectConstants';
import sortCollectionPointsByDistance from '../../../utils/collection/sortCollectionPointsByDistance';

function getFilteredCollectionPoints(collectionPoints, collectPlusFilter, alwaysShowCollectPlusFeatureActive) {
  let filteredCollectionPoints = [];

  filteredCollectionPoints = concat(filteredCollectionPoints, collectionPoints.filter(collectionPoint => (
    collectionPoint.ownerId !== COLLECT_PLUS_OWNER_ID
  )));

  if (collectPlusFilter.active || alwaysShowCollectPlusFeatureActive) {
    let collectPlusPoints = collectionPoints.filter(collectionPoint => (
      collectionPoint.ownerId === COLLECT_PLUS_OWNER_ID
    ));

    if (alwaysShowCollectPlusFeatureActive) {
      collectPlusPoints = collectPlusPoints.slice(0, 9);
    }

    filteredCollectionPoints = concat(filteredCollectionPoints, collectPlusPoints);
  }

  return sortCollectionPointsByDistance(filteredCollectionPoints);
}

export default getFilteredCollectionPoints;
